export const convertWidgetData = (widget) => widget;

// || ({
//   title: 'Ваша персональная скидка на iPhone, Samsung, Nokia, Xiaomi ждет вас!',
//   description: 'Ваш номер телефона - это ваш промокод',
//   numberFormDescription: 'Введите номер телефона, чтобы получить доступ к персональным скидкам',
//   smsFormDescription: 'На ваш телефон отправлено SMS с паролем для авторизации. ',
// eslint-disable-next-line max-len
//   smsCaptchaFormDescription: 'Какое-то описание того, что нашему любимому пользователю код в смс отправится только после ввода капчи.',
//   numberButton: 'К скидкам',
//   smsCodeButton: 'К скидкам',
//   captchaButton: 'Отправить код',
//   preAuthButton: 'Получить скидку',
//   authButton: 'К покупке',
//   errorTexts: {
//     smsCodeError: 'За сегодня вы исчерпали лимит SMS-кодов. Попробуйте завтра',
// eslint-disable-next-line max-len
//     otherError: 'Что-то пошло не так или указанный номер не принадлежит «Билайн». <a href="https://beeline.ru/mnp">Перейти в «Билайн» со своим номером.</a>',
//   },
//   redirectUrl: '/shop/catalog/actions/personalnyi-kod/',
//   offerUrl: '/customers/products/mobile/bonus/details/tvoy-nomer-telefona-tvoy-promokod-na-skidku/',
//   offerUrlTitle: 'Подробнее об акции',
//   background: '#6657a0 right / auto 100% no-repeat',
//   backgroundImage: 'https://static.beeline.ru/upload/images/e-shop/treefours/back_shop_horizontal15.jpg',
//   mobileBackground: '#12121b center / cover no-repeat',
//   mobileBackgroundImage: 'https://static.beeline.ru/upload/images/e-shop/treefours/444-banner-mobile15.jpg',
//   isLightTheme: true,
// });
